/** Initials, not a photograph: storing a patient's photo is a different consent
 *  conversation, and nothing in the brief asks for one.
 *
 *  Which is also why it is not a circle. A circular initials chip is the shape
 *  every consumer app uses for a profile picture, so it reads as a photograph
 *  that failed to load — in a patient list, beside a real name, that is a
 *  promise the app never keeps. A squircle reads as an identity field on a
 *  record, which is what it is, and matches the rounded-square lockup in the
 *  rail. The radius is a proportion rather than a token so the 64px header
 *  chip and the 32px rail chip are the same shape, not the same corner. */
export function Avatar({
  name,
  size = 40,
  title,
}: {
  name: string
  size?: number
  title?: string
}) {
  const initials = name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('')

  return (
    <span
      className="grid flex-none place-items-center overflow-hidden border border-accent-line bg-accent-soft leading-none font-semibold text-accent select-none"
      style={{
        width: size,
        height: size,
        fontSize: Math.round(size * 0.36),
        borderRadius: Math.round(size * 0.28),
      }}
      aria-hidden={title ? undefined : true}
      title={title}
    >
      {initials || '?'}
    </span>
  )
}
